module.exports = __webpack_public_path__ + "static/media/Awards_ET_ascent_smart_cities_leadership_award.68a49c92.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Awards_ET_ascent_smart_cities_leadership_award.webp
// module id = 341
// module chunks = 0